import React from 'react';
import SignInSection from './Sections/SignInSection';
import InfoPanel from 'application/Components/InfoPanel';
import { Layout } from 'application/Components/UI/Layouts/Layout';
import Utility from 'utils/Utility';
import { Helmet } from 'react-helmet';
import useAppids from 'hooks/useAppids';

const Login = () => {
  const { appid } = useAppids();
  // document.title = Utility.getTabTitle();

  return (
    <Layout>
      <Helmet>
        <title>{Utility.getTabTitle(appid)}</title>
      </Helmet>
      <SignInSection />
      <InfoPanel />
    </Layout>
  );
};

export default Login;
